import type { PaginationResponse } from '@/types/common'
import maxios from '@/utils/axios/maxios'

type TeachersResponse = PaginationResponse<res.Teacher[]>

// 선생님 API
const teacherApi = {
  // 선생님 가져오기
  getTeachers(pageQueryString: string) {
    return maxios.get<TeachersResponse>(`/teachers${pageQueryString}`)
  },
  // 내 선생님 정보 가져오기
  getOneTeacher() {
    return maxios.get<res.Teacher>(`/teachers/me`)
  },
  // 특정 선생님의 난이도 설정 가져오기
  getTeacherSetting: () => {
    return maxios.get<res.TeacherSetting>(`/teachers/setting`)
  },
  // 선생님 생성하기
  postTeacher: (teacher: req.CreateTeacher) => {
    return maxios.post('/teachers', teacher)
  },
  // 특정 선생님의 난이도 설정 변경하기
  putTeacherSetting: (data: req.TeacherSetting) => {
    return maxios.put(`/teachers/setting`, data)
  },
  // 내 선생님 정보 수정하기
  patchMyTeacher(teacher: req.PatchMyTeacher) {
    return maxios.patch(`/teachers/me`, teacher)
  },
  // [변경] 특정 선생님 정보 수정하기 (선생님 관리)
  patchTeacherById(teacher: req.PatchTeacher) {
    return maxios.patch(`/teachers`, teacher)
  },
  // 선생님 삭제하기
  deleteTeachers(teacherIds: req.TeacherId[]) {
    return maxios({
      url: '/teachers/by-ids',
      method: 'DELETE',
      data: { teacherIds },
    })
  },
  resetTeacherPassword(teacherId: req.TeacherId) {
    return maxios.patch(`/teachers/${teacherId}/password-reset`)
  },
  getActivityCount() {
    return maxios.get<res.ActivityCount>(`/teachers/activity-counts`)
  },
  markLogin() {
    return maxios.post<{ firstLogin: boolean }>('/teachers/me/login')
  },
}

export default teacherApi
